import React from 'react';
import './Maintenance.css';
import hkclLogo from '../../assets/hkcl.png';

const Maintenance = () => {
  return (
    <div
      className="maintenance-container"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        margin: 0,
        padding: '20px',
        fontFamily: 'Arial, sans-serif'
      }}
    >
      <div 
        className="text-center"
        style={{
          backgroundColor: '#f8f9fa',
          padding: '60px 40px',
          borderRadius: '20px',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
          maxWidth: '600px',
          width: '100%'
        }}
      >
        {/* Official Header */}
        <div className="mb-4">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
            <img 
              src="/logo.jpg" 
              alt="GJU Logo" 
              style={{
                width: '80px',
                height: 'auto',
                maxWidth: '100%',
                filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
              }}
            />
            <img 
              src={hkclLogo} 
              alt="HKCL Logo" 
              style={{
                width: '80px',
                height: 'auto',
                maxWidth: '100%',
                filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))'
              }}
            />
          </div>
          <div 
            style={{
              fontSize: '1.1rem',
              color: '#2c3e50',
              fontWeight: '600',
              marginBottom: '10px'
            }}
          >
            GURU JAMBHESHWAR UNIVERSITY OF SCIENCE & TECHNOLOGY
          </div>
         
        </div>        
        <h1 
          style={{ 
            color: '#2c3e50',
            fontSize: '1.5rem',
            fontWeight: '700',
            marginBottom: '20px',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}
        >
          Under Maintenance
        </h1>
        


        {/* Footer */}
        <div 
          style={{
            fontSize: '0.8rem',
            color: '#95a5a6',
            marginTop: '5px',
            paddingTop: '10px',
            borderTop: '1px solid #ecf0f1'
          }}
        >
          © 2026 Guru Jambheshwar University | Directorate of Open & Distance Education
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
